import form from './index.js'

export function paydown(data) {
    return form.bodyrequest('/order/create', data)
}

export function getpaymethods(data) {
    return form.getrequest('/payConfig/product', data)
}

export function testpaystatus(data) {
    return form.getrequest('order/status', data)
}